export function schema_sequence(prevColumnNames) {
	return {
		title: "Séquence",
		properties: {
			sequences: {
				title: "Séquences",
				type: "array",
				default: [[{}]],
				items: {
					title: "Séquence",
					type: "object",
					format: "categories",
					properties: {
						sequence: {
							title: "Séquence",
							format: "table",
							type: "array",
							default: [{}],
							items: {
								title: "Eléments",
								type: "object",
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: [
											"texte",
											"séquence",
											"regex",
											"nombre",
											"mots",
											"nombre décimal",
											"date (jour/mois/année)",
											"téléphone",
											"code postal",
										],
									},
									regex: {
										title: "Regex ou valeur",
										type: "string",
									},
									nb: {
										title: "Occurences",
										type: "string",
										enum: ["un", "plusieurs"],
									},
									column: {
										title: "Mapping",
										type: "string",
									},
									required: {
										title: "Obligatoire",
										type: "boolean",
										format: "checkbox",
									},
									temporary: {
										title: "Temp",
										type: "boolean",
										format: "checkbox",
									},
								},
							},
						},
						sequence_options: {
							title: "Séquence - options",
							format: "table",
							type: "array",
							default: [{}],
							items: {
								title: "Eléments",
								type: "object",
								properties: {
									column: {
										title: "mapping",
										type: "string",
									},
									max: {
										title: "Max",
										type: "boolean",
										format: "checkbox",
									},
								},
							},
						},
						options: {
							title: "Options",
							type: "object",
							properties: {
								name: {
									title: "Nom",
									type: "string",
								},
								column: {
									title: "Colonne",
									type: "string",
								},
								object: {
									title: "Objet",
									type: "boolean",
									format: "checkbox",
								},
								parent: {
									title: "Parent",
									type: "boolean",
									format: "checkbox",
								},
								strict: {
									title: "Strict",
									type: "boolean",
									format: "checkbox",
								},
								group_regex: {
									title: "Groupe de regex",
									type: "boolean",
									format: "checkbox",
								},
								separator: {
									title: "Séparateur",
									type: "string",
									default: " ",
								},
							},
						},
					},
				},
			},
			column: {
				title: "Colonne",
				type: "string",
			},
		},
	};
}
